module.exports = __webpack_public_path__ + "img/pwa-install-popup-bg.6df92605.png";